/**
 * Domain Validator
 * Client-side domain validation (preliminary check)
 * Server will do the authoritative validation
 * Module 2, Section 5.1
 */

export class DomainValidator {
  /**
   * Check if current domain might be allowed
   * This is a preliminary check - server validates authoritatively
   */
  public static isLikelyAllowed(allowedDomains: string[]): boolean {
    const currentDomain = window.location.hostname;
    
    return allowedDomains.some(allowed => {
      // Exact match
      if (allowed === currentDomain) {
        return true;
      }
      
      // Wildcard subdomain match (*.example.com)
      if (allowed.startsWith('*.')) {
        const baseDomain = allowed.substring(2);
        return currentDomain.endsWith(baseDomain);
      }
      
      return false;
    });
  }
  
  /**
   * Get current domain info
   */
  public static getCurrentDomain(): string {
    return window.location.hostname;
  }
  
  /**
   * Get full origin
   */
  public static getCurrentOrigin(): string {
    return window.location.origin;
  }
  
  /**
   * Get referrer (for server-side validation)
   */
  public static getReferrer(): string {
    return document.referrer || window.location.href;
  }
}
